import { Component } from '../Component';
import { ArgSpecDictionary } from '../ComponentUtils';

const DEBUG_VERBOSE: boolean = false;
export const HHDSImageGridTagName: string = 'hhds-image-grid';
const TAG_NAME: string = HHDSImageGridTagName;
const LOG_PREFIX: string = `[${TAG_NAME}]`;

export const HHDSImageGridAttrNames = {};

//const Attrs = HHDSImageGridAttrNames;

export class HHDSImageGrid extends Component {
	constructor() {
		super();
	}

	protected override init(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'init');

		const html: string = `
      <div class="${TAG_NAME} container">
				<div class="grid">
					<div class="col-span-4 md:col-span-4 lg:col-span-8 ${TAG_NAME}--first-image">
						<slot name='image-1'></slot>
					</div>
					<div class="col-span-2 md:col-span-4 lg:col-span-8">
						<slot name='image-2'></slot>
					</div>
					<div class="col-span-2 md:col-span-4 lg:col-span-8">
						<slot name='image-3'></slot>
					</div>
				</div>
			</div>
    `;

		this.setInnerHtml('', '', html);
	}

	protected override destroy(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'destroy');
	}

	override onAttributeChanged(name: string, _oldValue: string, _newValue: string): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onAttributeChanged: ${name}`);
		this.reinit();
	}

	override onSlotChange(_slot: HTMLSlotElement, _elements: HTMLElement[]): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onSlotChange`);
	}

	static override argSpecs(): ArgSpecDictionary {
		return ArgSpecs;
	}
}

export const ArgSpecs: ArgSpecDictionary = {};
